import PropTypes from 'prop-types';
import { Link } from '@blaze-cms/nextjs-components';
import MenuListItem from './MenuListItem';

const MenuList = ({ handleClick, headerMenu, itemHref, itemName }) => {
  const linkName = `${itemName} HOME`;

  return (
    <div className="menu__content menu__content--responsive-nav">
      <ul className="menu__list menu__list--responsive-nav">
        {itemName && (
          <li className="menu__list-item menu__list-item--responsive-nav">
            <Link href={itemHref} onClick={() => handleClick({ itemAction: 'close' })}>
              {linkName}
            </Link>
          </li>
        )}
        {headerMenu.map(item => (
          <MenuListItem key={item.name} handleClick={handleClick} {...item} itemName={itemName} />
        ))}
      </ul>
    </div>
  );
};

MenuList.propTypes = {
  handleClick: PropTypes.func.isRequired,
  headerMenu: PropTypes.array,
  itemHref: PropTypes.string.isRequired,
  itemName: PropTypes.string.isRequired
};

MenuList.defaultProps = {
  headerMenu: []
};

export default MenuList;
